import React, { useCallback, useEffect, useRef, useState } from 'react';
import { InputStatusModel } from 'features/worksheet/process/job/models';
import { Link } from 'react-router-dom';
import { MdOutlineCancel, MdOutlineCheckCircleOutline } from 'react-icons/md';
import { BiEditAlt } from 'react-icons/bi';
import DefaultModal from 'components/Modal/DefaultModal';
import JobChangeStatus from 'features/worksheet/process/job/components/JobChangeStatus';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import { RootState } from 'app/store';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { cancelMRE, getWaitingMRE, reset } from '../processMRE.reducer';
import { customStatusOption, customWarnOption } from 'helpers/alertLabel';
import {
    cancelJob,
    changeStatusJob,
    checkJob,
    reset as resetJob,
} from 'features/worksheet/process/job/job.reducer';
import { AiOutlineHistory } from 'react-icons/ai';
import { HttpClientError, RequestStatus } from 'http-client';
import { filterParams } from '../../../../../helpers/agTable';
import { rowNumberRenderer } from '../../../../../components/DataGrid/agGridCustomProps';
import { UserCredential } from '../../../../login/models';
import { checkRoleActionAccess } from '../../../../../routes/checkRoleAccess';
import { ActionEnum, MenuEnum } from '../../../../../routes/models';
import AgDataGrid from '../../../../../components/DataGrid/AgDataGrid';
import FormLoader from '../../../../../components/Loader/FormLoader';
import { pendingJob } from 'features/worksheet/jobData/jobCheck/jobCheck.reducer';
import { dateWithTime } from 'helpers/convert';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { TbRefreshAlert } from 'react-icons/tb';
import { JOB_STATUS_NEW_MRE } from '../../../../../constants';
import { RiEditCircleFill } from 'react-icons/ri';
import MREChangeStatus from './MREChangeStatus';

const JobCheckTable = () => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);
    const gridRef = useRef<any>(null);

    const user = useAppSelector(
        (state: RootState) => state.user.userAuth ?? ({} as UserCredential),
    );
    const jobCheckList = useAppSelector(
        (state: RootState) => state.processMRE.waitingMREList ?? [],
    );
    const isLoading = useAppSelector(
        (state: RootState) => state.processMRE.isGetWaitingMRELoading ?? false,
    );
    const actionStatus = useAppSelector(
        (state: RootState) => state.job.actionStatus,
    );
    const error = useAppSelector(
        (state: RootState) => state.job.error ?? ({} as HttpClientError),
    );
    const actionPendingStatus = useAppSelector(
        (state: RootState) => state.jobCheck.actionStatus,
    );
    const errorPending = useAppSelector(
        (state: RootState) => state.jobCheck.error ?? ({} as HttpClientError),
    );
    const userState = useAppSelector(
        (state: RootState) => state.user.userAuth ?? ({} as UserCredential),
    );
    const actionStatusMre = useAppSelector(
        (state: RootState) => state.processMRE.actionStatus,
    );
    const errorMre = useAppSelector(
        (state: RootState) => state.processMRE.error ?? ({} as HttpClientError),
    );

    const [showModal, setShowModal] = useState<boolean>(false);
    const [action, setAction] = useState<string>('');
    const [jobId, setJobId] = useState<string>('');
    const [tableName, setTableName] = useState('');

    const [showChangeMreStatusModal, setShowChangeMreStatusModal] =
        useState<boolean>(false);

    useEffect(() => {
        dispatch(getWaitingMRE({ skip: 0, take: 10 }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (
            tableName === 'waiting' &&
            actionStatus !== undefined &&
            actionStatus !== RequestStatus.pending
        ) {
            MySwal.fire(
                customStatusOption(
                    actionStatus === RequestStatus.success,
                    error.data?.message,
                    'status has been changed!',
                    'failed to change status',
                ),
            ).then(() => {
                dispatch(resetJob());
                dispatch(getWaitingMRE({ skip: 0, take: 10 }));
                // refreshCache(undefined);
                setShowModal(false);
                setTableName('');
            });
        } else if (
            tableName === 'waiting' &&
            actionPendingStatus !== undefined &&
            actionPendingStatus !== RequestStatus.pending
        ) {
            MySwal.fire(
                customStatusOption(
                    actionPendingStatus === RequestStatus.success,
                    errorPending.data?.message,
                    'status has been changed!',
                    'failed to change status',
                ),
            ).then(() => {
                dispatch(reset());
                dispatch(getWaitingMRE({ skip: 0, take: 10 }));
                // refreshCache(undefined);
                setShowModal(false);
                setTableName('');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableName, actionStatus, actionPendingStatus, error, errorPending]);

    useEffect(() => {
        if (
            actionStatus !== undefined &&
            actionStatus !== RequestStatus.pending
        ) {
            MySwal.fire(
                customStatusOption(
                    actionStatus === RequestStatus.success,
                    error.data?.message,
                    'status has been changed!',
                    'failed to change status',
                ),
            ).then(() => {
                dispatch(resetJob());
                dispatch(getWaitingMRE({ skip: 0, take: 10 }));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionStatus, error]);

    useEffect(() => {
        if (
            actionStatusMre !== undefined &&
            actionStatusMre !== RequestStatus.pending
        ) {
            MySwal.fire(
                customStatusOption(
                    actionStatusMre === RequestStatus.success,
                    errorMre.data?.message,
                    'status has been changed!',
                    'failed to change status',
                ),
            ).then(() => {
                dispatch(reset());
                dispatch(getWaitingMRE({ skip: 0, take: 10 }));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionStatusMre, errorMre]);

    const toggleModal = () => {
        setShowModal((prevState) => !prevState);
        setAction('');
        setJobId('');
    };

    const openModal = (action: string, id: string) => {
        setAction(action);
        setShowModal(true);
        setJobId(id);
    };

    const onStatusClicked = (
        id: string,
        action: string,
        data?: InputStatusModel,
    ) => {
        MySwal.fire(
            customWarnOption(
                'Change Status',
                'Are you sure you want to change the status',
            ),
        ).then((result) => {
            if (result.isConfirmed) {
                switch (action) {
                    case 'checked':
                        dispatch(
                            checkJob({ job_id: id, user_id: user.user_id }),
                        );
                        setTableName('waiting');
                        break;
                    case 'pending':
                        dispatch(pendingJob({ id, userId: userState.user_id }));
                        setTableName('waiting');
                        break;
                    case 'cancel':
                        dispatch(
                            cancelJob({
                                job_id: id,
                                cancel_notes: data?.notes ?? '',
                                waiting_by_user: user.user_id,
                            }),
                        );
                        setTableName('waiting');
                        break;
                    default:
                        break;
                }
            }
        });
    };

    const ActionCellRender = (props: any) => {
        return (
            <div className="flex align-middle h-[100%]">
                <button onClick={() => showNotes(props.data)}>
                    <IoInformationCircleOutline className="mx-1 text-2xl text-primary-color" />
                </button>
                <button onClick={() => onActionMREClicked(props.data?.id)}>
                    <TbRefreshAlert className="mx-1 text-2xl text-primary-color" />
                </button>
                <button
                    onClick={() =>
                        openChangeMreStatusModal('cancel', props.data?.id)
                    }
                >
                    <MdOutlineCancel className="mx-1 text-2xl text-primary-color" />
                </button>
                <button>
                    <Link
                        to={{
                            pathname: `/worksheet/job/detail/${props.data?.id}`,
                            search: `?from=check-job`,
                        }}
                    >
                        <RiEditCircleFill className="mx-1 text-2xl text-primary-color" />
                    </Link>
                </button>
            </div>
        );
    };

    const openChangeMreStatusModal = (action: string, id: string) => {
        setShowChangeMreStatusModal(true);
        setJobId(id);
    };

    const showNotes = (data: any) => {
        MySwal.fire({
            html: (
                <div className="flex">
                    <div className="text-left">
                        <div className="font-bold text-sm">
                            Last Checked By :{' '}
                            <span className="font-normal text-sm">
                                {data?.waiting_by_user_name}
                            </span>
                        </div>
                        <div className="font-bold text-sm">
                            Last Checked Date :{' '}
                            <span className="font-normal text-sm">
                                {dateWithTime(
                                    data?.waiting_ts ?? '0001-01-01T00:00:00',
                                )}
                            </span>
                        </div>
                        <div className="font-bold text-sm">
                            Notes :{' '}
                            <span className="font-normal text-sm">
                                {data?.waiting_notes}
                            </span>
                        </div>
                    </div>
                </div>
            ),
        });
    };

    // change status to new mre
    const onActionMREClicked = (job_id: string) => {
        MySwal.fire(
            customWarnOption(
                'Active Job',
                'Are you sure to active this MRE job? You will not be able to recover this later!',
            ),
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch(
                    changeStatusJob({
                        job_id: job_id,
                        status: JOB_STATUS_NEW_MRE,
                        userId: user.user_id,
                    }),
                );
            }
        });
    };

    const JobNumberLinkCellRender = (props: any) => (
        <Link
            to={`/worksheet/ocalc/job-detail/${props.data?.id}`}
            className="underline text-blue-700"
        >
            {props.data?.number_job}
        </Link>
    );

    const [columnDefs, _setColumnDefs] = useState([
        {
            headerName: '#',
            field: 'rowNumber',
            cellRenderer: rowNumberRenderer, // Use the custom cell renderer
            suppressSizeToFit: true,
            // sortable: false,
            // filter: false,
        },
        {
            field: 'sales_order',
            headerName: 'Sales Order',
            // sortable: false,
            // filter: false,
            filter: true,
            sortable: true,
        },
        {
            field: 'number_id',
            headerName: 'ID Number',
            // sortable: true,
            // filter: 'agTextColumnFilter', filterParams: {
            //     filterOptions: ['contains'],
            //     maxNumConditions: 1,
            // }
            filter: true,
            sortable: true,
        },
        {
            headerName: 'Job Number',
            field: 'number_job',
            suppressCellFlash: true,
            cellRenderer: JobNumberLinkCellRender,
            filter: true,
            sortable: true,
            // sortable: true,
            // filter: 'agTextColumnFilter', filterParams: {
            //     filterOptions: ['contains'],
            //     maxNumConditions: 1,
            // }
        },
        {
            field: 'project_name',
            headerName: 'Project',
            // sortable: true,
            // filter: 'agTextColumnFilter', filterParams: {
            //     filterOptions: ['contains'],
            //     maxNumConditions: 1,
            // }
            filter: true,
            sortable: true,
        },
        {
            field: 'department_owner_name',
            headerName: 'Department Owner',
            // sortable: false,
            // filter: false,
            filter: true,
            sortable: true,
        },
        {
            field: 'kind_name',
            headerName: 'KoJ',
            // sortable: true,
            // filter: 'agTextColumnFilter', filterParams: {
            //     filterOptions: ['contains'],
            //     maxNumConditions: 1,
            // }
            filter: true,
            sortable: true,
        },
        {
            field: 'waiting_by_user_name',
            headerName: 'Waiting By',
            // sortable: false,
            // filter: false,
            filter: true,
            sortable: true,
        },
        {
            field: 'waiting_ts',
            headerName: 'Waiting Date',
            cellDataType: 'date_time',
            // sortable: false,
            // filter: false,
            filter: 'agDateColumnFilter',
            filterParams: filterParams,
        },
        {
            field: 'waiting_subject_name',
            headerName: 'Waiting Subject',
            // sortable: false,
            // filter: false,
            filter: true,
            sortable: true,
        },
        {
            field: 'waiting_notes',
            headerName: 'Waiting Notes',
            // sortable: false,
            // filter: false,
            filter: true,
            sortable: true,
        },
        {
            field: 'ts_created',
            headerName: 'Request Date',
            // cellDataType: 'date',
            cellDataType: 'date_time',
            sortable: true,
            // filter: 'agDateColumnFilter',
            // filterParams: {
            //     filterOptions: ['inRange'],
            //     maxNumConditions: 1,
            // },
            filter: 'agDateColumnFilter',
            filterParams: filterParams,
        },
        {
            field: 'status_name',
            headerName: 'Status',
            // sortable: true,
            // filter: 'agTextColumnFilter', filterParams: {
            //     filterOptions: ['contains'],
            //     maxNumConditions: 1,
            // }
            filter: true,
            sortable: true,
        },
        {
            field: 'type_name',
            headerName: 'Type',
            // sortable: false,
            // filter: false,
            filter: true,
            sortable: true,
        },
        {
            field: 'district_name',
            headerName: 'District',
            // sortable: true,
            // filter: 'agTextColumnFilter', filterParams: {
            //     filterOptions: ['contains'],
            //     maxNumConditions: 1,
            // }
            filter: true,
            sortable: true,
        },
        {
            field: 'po_number',
            headerName: 'PO Number',
            // sortable: false,
            // filter: false,
            filter: true,
            sortable: true,
        },
        {
            field: 'date_due',
            headerName: 'Due Date',
            cellDataType: 'date_time',
            // cellDataType: 'date',
            sortable: true,
            // filter: 'agDateColumnFilter',
            // filterParams: {
            //     filterOptions: ['inRange'],
            //     maxNumConditions: 1,
            // },
            filter: 'agDateColumnFilter',
            filterParams: filterParams,
        },
        {
            field: 'pole_total',
            headerName: 'Req Pole',
            // sortable: false,
            // filter: false,
            filter: true,
            sortable: true,
        },
        {
            field: 'last_check_date',
            headerName: 'Last Checked',
            // cellDataType: 'date',
            filter: 'agDateColumnFilter',
            filterParams: filterParams,
            cellDataType: 'date_time',
            // sortable: true,
            // filter: 'agDateColumnFilter',
            // filterParams: {
            //     filterOptions: ['inRange'],
            //     maxNumConditions: 1,
            // },
        },
        {
            field: 'last_check_user_name',
            headerName: 'Last Checked By',
            // sortable: false,
            // filter: false,
            filter: true,
            sortable: true,
        },
        {
            headerName: 'Actions',
            field: 'actions',
            pinned: 'right',
            suppressCellFlash: true,
            minWidth: 220,
            cellRenderer: ActionCellRender,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }),
        },
    ]);

    const toggleChangeMreStatusModal = () => {
        setShowChangeMreStatusModal((prevState) => !prevState);
        setJobId('');
    };

    const onMreStatusClicked = (
        id: string,
        action: string,
        data?: InputStatusModel,
    ) => {
        MySwal.fire(
            customWarnOption(
                'Cancel MRE',
                'Are you sure you want to cancel the MRE?',
            ),
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch(
                    cancelMRE({
                        job_id: id,
                        cancel_notes: data?.notes ?? '',
                        waiting_by_user: user.user_id,
                    }),
                );
            }
        });
    };

    const refreshCache = useCallback((route: any) => {
        const purge = !!document?.querySelector('#purge' as any)?.checked;
        gridRef.current.api.refreshServerSide({ route: route, purge: purge });
    }, []);

    return (
        <div>
            <div className="main-data-grid mt-5">
                <FormLoader isLoading={isLoading} label={'Fetching Data'}>
                    <AgDataGrid
                        rowData={jobCheckList}
                        columnDefs={columnDefs}
                        supportSaveTableState
                        tableStateName={'job-data-check-job'}
                        defaultPageSize={20}
                    />
                </FormLoader>
                {/*<AgDataGridServerPaging ref={gridRef} columnDefs={columnDefs}*/}
                {/*                        getServerSideDataSource={getServerSideDataSource} supportSaveTableState*/}
                {/*                        tableStateName={'job-data-check-job'} defaultPageSize={20}/>*/}
                <DefaultModal
                    title="Change Status"
                    show={showModal}
                    onClose={toggleModal}
                    body={
                        <JobChangeStatus
                            action={action}
                            jobId={jobId}
                            onSubmit={onStatusClicked}
                        />
                    }
                />
            </div>
            <DefaultModal
                title="Change MRE Status"
                show={showChangeMreStatusModal}
                onClose={toggleChangeMreStatusModal}
                body={
                    <MREChangeStatus
                        action={'cancel'}
                        jobId={jobId}
                        onSubmit={onMreStatusClicked}
                    />
                }
            />
        </div>
    );
};

export default JobCheckTable;
